var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollabsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 15,
    viewBox: "0 0 25 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_427_4838",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 15
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.07571 0C2.99633 0 0.5 2.56956 0.5 5.73927L0.5 12.7368C0.5 13.811 1.37081 14.6819 2.44501 14.6819C3.51922 14.6819 4.39003 13.811 4.39003 12.7368V5.73927C4.39003 4.78099 5.14473 4.00414 6.07571 4.00414C7.00668 4.00414 7.76139 4.78099 7.76139 5.73927V6.67357H11.6514V5.73927C11.6514 2.56956 9.15509 0 6.07571 0Z",
    fill: "#FF065C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5244 0C15.445 0 12.9487 2.56956 12.9487 5.73927V6.67357H16.8387V5.73927C16.8387 4.78099 17.5934 4.00414 18.5244 4.00414C19.4554 4.00414 20.2101 4.78099 20.2101 5.73927V12.7368C20.2101 13.811 21.0809 14.6819 22.1551 14.6819C23.2293 14.6819 24.1001 13.811 24.1001 12.7368V5.73927C24.1001 2.56956 21.6038 0 18.5244 0Z",
    fill: "#FF065C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2994 14.6827C9.79294 14.6827 7.76105 12.6508 7.76105 10.1444V6.67445H11.6511V9.99887C11.6511 10.3569 11.9414 10.6472 12.2994 10.6472C12.6575 10.6472 12.9478 10.3569 12.9478 9.99887V6.67445H16.8378V10.1444C16.8378 12.6508 14.8059 14.6827 12.2994 14.6827Z",
    fill: "#FF065C"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_427_4838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 899"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 46",
    cx: 23.7307,
    cy: 24.4236,
    rx: 23.7307,
    ry: 24.4236,
    transform: "matrix(0.999965 0.00833615 -0.0077454 0.99997 -1.82312 -22.7561)",
    fill: "#FFAC39"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 47",
    cx: 23.7307,
    cy: 24.4236,
    rx: 23.7307,
    ry: 24.4236,
    transform: "matrix(0.999965 0.00833615 -0.00774541 0.99997 -21.4249 -3.42932)",
    fill: "#FF065C"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 48",
    cx: 23.7307,
    cy: 24.4236,
    rx: 23.7307,
    ry: 24.4236,
    transform: "matrix(0.999965 0.00833615 -0.0077454 0.99997 -33.1511 -29.4209)",
    fill: "#1F3FFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabsIcon);
export default __webpack_public_path__ + "static/media/collabs-icon.0fcb2a0c8dfb025faa668196425b10e2.svg";
export { ForwardRef as ReactComponent };